<template>
    <button
        class="max-sm:w-[50%] max-sm:h-[45px] h-[50px] py-1 px-5 text-xs rounded-sm shadow-lg font-semibold border border-[#a8a7a7] hover:bg-[#444]"
        :class="{'text-[#ffffff] bg-[#12760A]': enabled, 'text-[#ececec] bg-[#8d8d8a]' :!enabled}"
        v-text="name"/>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({

    data(){
        return{

        }
    },
    props:{
        enabled:{
            type: Boolean,
            default: true,
        },
        name:{
            type: String,
            default: "BUTTON NAME"
        },

    }
})

</script>